import {
  MinimalRelationship,
  PrefixedID,
  Relationship,
  RelationshipUpdate,
} from '@griply/types';

export type ResolvedRelationshipWrites = {
  toCreate: MinimalRelationship[];
  toUpdate: MinimalRelationship[];
};

export const resolveRelationshipWrites = (
  updates: RelationshipUpdate[],
  relationships: Relationship[],
): ResolvedRelationshipWrites => {
  const existing = new Map(
    relationships.map((relationship) => [relationship.id, relationship]),
  );
  const resolved = new Map<PrefixedID, MinimalRelationship>();
  const replaced = new Set<PrefixedID>();

  updates.forEach(({ id, add, remove, replace }) => {
    if (!(add?.length || remove?.length || replace)) {
      return;
    }
    replace && replaced.add(id);

    const current = resolved.get(id) ?? {
      id,
      references: [...(existing.get(id)?.references ?? [])],
    };

    const added = add?.length
      ? Array.from(new Set([...current.references, ...add]))
      : current.references;
    const removed = remove?.length
      ? added.filter((reference) => !remove.includes(reference))
      : added;

    resolved.set(id, { ...current, references: replace ?? removed });
  });

  const toCreate: MinimalRelationship[] = [];
  const toUpdate: MinimalRelationship[] = [];

  resolved.forEach((relationship, id) => {
    if (existing.has(id)) {
      toUpdate.push(relationship);
      return;
    }

    // Clearing links on an owner that has no document is a no-op — unless the caller named the full set: that owner's doc may exist unseen.
    if (!relationship.references.length && !replaced.has(id)) {
      return;
    }

    toCreate.push(relationship);
  });

  return { toCreate, toUpdate };
};
